// By convention, the first answer is always
// the correct one. We'll shuffle them before
// displaying them.
const questions = [
  {
    question: 'What is React?',
    answers: [
      "It's a framework",
      "It's a language",
      "It's like Facebook"
    ]
  },
  {
    question: 'What is JavaScript?',
    answers: [
      "It's a language",
      "It's a framework",
      "It's the same as Java",
    ]
  }
]

export default questions;